$(document).ready(function(){

    function checker() {
      var customerId = $('.js-cst-id').val();
      var url = "/admin/customers/"+customerId+".json";
      $.ajax({
        type: "GET",
        url: url,
        success: function(data){
          console.log(data);
        }
      });
    }

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
    }

    function jwtEncode (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
  
      return JSON.parse(jsonPayload);
    };

    function my_round(num) {
      return Math.round(num * 10 * 10) / 100;
    }

    Number.prototype.isBetween = function(a, b) {
      var min = Math.min(a, b),
          max = Math.max(a, b);
    
      return this > min && this < max;
    };

    function calculationWh() {
      let startWh = $('.js-start-wh').val(),
          finalWh = $('.js-final-wh').val(),
          calculated = $('.js-percent-wh');

      if (startWh != '' && finalWh != '') {
        let finalVr = finalWh / startWh * 100,
            peas = $('.materials-table__range').toArray(),
            calcalatedValue = my_round(finalVr) + '';

        calculated.text(calcalatedValue.replace('.', ','))
        $('.js-label').text('')
        $('.js-innoc a').attr('href', '')
        $('.js-innoc a').text('')
        $('.materials-calc__block.m-fnl').css('background', '#f8f8f8')

        $.each($('.materials-table__range'), i => {
          if (finalVr.isBetween($(peas[i])[0].dataset.range1, $(peas[i])[0].dataset.range2)) {
            let label = $(peas[i]).closest('.materials-table__block').find('.materials-table__description span:last-child').text(),
                inoculateHref = $(peas[i]).closest('.materials-table__block').find('.materials-table__product a').attr('href'),
                inoculateTitle = $(peas[i]).closest('.materials-table__block').find('.materials-table__product a').text(),
                color = $(peas[i]).closest('.materials-table__block').find('.materials-table__description span:first-child').data('color');

            $('.js-label').text(label)
            $('.js-innoc a').attr('href', inoculateHref)
            $('.js-innoc a').text(inoculateTitle)
            $('.js-innoc a').addClass('m-sh')
            $('.materials-calc__block.m-fnl').css('background', color)
          }
        });

      }

    };

    $('.materials-table__range').each(function () {
      let data = $(this).text(),
          arr = data.split(' - '),
          range1 = arr[0].replace(',', '.'),
          range2 = arr[1].replace(',', '.');

      $(this).attr('data-range1', range1)
      $(this).attr('data-range2', range2)
    });
    
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;
  
      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
  
          if (sParameterName[0] === sParam) {
              return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
    };

    var urlParam = getUrlParameter('log'),
      urlParamN = getUrlParameter('rd');

    if (urlParam == 'true') {
      localStorage.setItem('logined', 'true');
    }

    if (localStorage.logined == 'true' && window.location.href.indexOf("account/login") > -1) {

      let loginButton = '.template-customers-login .header_login input';

      $(document).arrive(loginButton, function() {
        localStorage.setItem('logined', 'false');
        $(loginButton).trigger('click')
      });

    }

    function apiCortevaCall() {
      let curl = "https://enterprise-dm-accountprefsbl-api-prod.azurewebsites.net/api/v1.0/accountprofileservice/fetchGlobalProfile",
          token =  getCookie("mo_token"),
          accessToken = token;
          decodedToken = jwtEncode(accessToken),
          guidToken = '{"guid": "'+decodedToken.oid+'"}';

      $.ajax({
        type: "post",
        url: curl,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer '+accessToken+'');
        },
        data: ''+guidToken+'',
        crossDomain: true,
        dataType:'json',
        headers: {
          'Content-Type': 'application/json',
          'app': 'shopify',
          'brand': 'Corteva',
          'country': 'DE',
          'language': 'de'
        },
        error: function(result){
          $('.first-name, .last-name, .phone').hide()
          $('.myaccount_info').removeClass('m-load')
        },
        success: function (result) {
          let firstName = '',
              lastName = '',
              phone;
    
          if (result.data != null) {
            if(result.data.firstName) {
              firstName = result.data.firstName;
              $('.first-name').show()
            } else {
              firstName = '';
            }
            if(result.data.lastName) {
              lastName = result.data.lastName;
              $('.last-name').show()
            } else {
              lastName = '';
            }
            if(result.data.communicationPreferences.mobilePhone) {
              phone = result.data.communicationPreferences.mobilePhone;
              $('.phone').show()
            } else {
              phone = '';
            }
          } else {
            firstName = '';
            lastName = '';
            phone = '';
            $('.first-name').hide();
            $('.last-name').hide();
            $('.phone').hide();
          }

          $('.first-name div:last-child').text(firstName);
          $('.last-name div:last-child').text(lastName);
          $('.phone div:last-child').text(phone);
          $('.myaccount_info').removeClass('m-load')
        },
      });
    }

    if ($('.myaccount_info').length) {
      apiCortevaCall()
    }

    $(document).on("click", ".js-tab", function() {
      let tab = $(this).data('tab');
      $('.js-tab').removeClass('m-active')
      $(this).addClass('m-active')
      $('.m-tabs .grid__item').hide()
      $('.m-tabs .grid__item[data-tab="'+tab+'"]').show()
    });

    $(document).on("click", ".js-prevent", function(e) {
      e.preventDefault();
    });

    $(document).on("click", ".m-opened .js-prevent", function(e) {
      window.location.href = e.target.href
    });

    $(document).on("click", ".m-signed-customer a", function(e) {
      $('.m-signed-customer').addClass('m-opened')
    });

    $(document).on("click", ".site-header__account", function(e) {
      let loginAttr = $(this).attr('href')
      if (loginAttr == '/account/login') {
        e.preventDefault()
        $('.js-login-hd input').trigger('click')
      }
    });

    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.m-signed-customer').length && 
      $('.m-signed-customer').hasClass("m-opened")) {
        $('.m-signed-customer').removeClass('m-opened')
      }        
    });

    $(document).on("change", ".js-start-wh, .js-final-wh", function(e) {
      calculationWh()
    });

    function listCookies() {
      var theCookies = document.cookie.split(';');
      var aString = '';

      for (var i = 1 ; i <= theCookies.length; i++) {
        aString += i + ' ' + theCookies[i-1] + "\n";
      }

      return aString;
    }

    let helpSideber = $('.help-m-menu')

    if (helpSideber.length) {
      $('.js-sidebar-inner').append(helpSideber)
    }

    if ($('.section-tabs').length) {

      if ($(window).width() <= 768) {
        $('.section-tabs__link').addClass('m-off')

        
        $(document).on("click",".section-tabs__list",function() {
          $(this).toggleClass('m-open')
          $('.section-tabs__link').toggleClass('m-off')
        });
      }
    
      var sticky = $('.section-tabs'),
      sectionsTabsContent = $('.section-tabs-content'),
      origOffsetY = sticky.offset().top;


      function onScroll(e) {

        if ( window.scrollY >= origOffsetY) {
          sticky.addClass('m-fixed');
          sectionsTabsContent.addClass('m-fixed');
        } else {
          sticky.removeClass('m-fixed');
          sectionsTabsContent.removeClass('m-fixed');
        }   
      }

      document.addEventListener('scroll', onScroll);

      $(window).scroll(function () {

          var scrollDistance = $(window).scrollTop();

          $('.product__section').each(function (i) {
            if ($(this).position().top - 51 <= scrollDistance) {
              $('.section-tabs__item.active').removeClass('active');
              $('.section-tabs__item').eq(i).addClass('active');
            }
          });

      }).scroll();

    }

    if ($('body').hasClass('template-product')) {

      var settings = {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      
      gallerySlider = new Swiper('.js-modal-slider', settings);
  

      function sliderClose() {
        $('body').removeClass('m-ovrf')
        $('.m-product-gallery').hide()
      }

      $(document).on("click",".product-gallery-img",function() {
        $('body').addClass('m-ovrf')
        let activeSlide = $(this).data('index');
        $('.m-product-gallery').show()

        gallerySlider.destroy();
        gallerySlider = new Swiper('.js-modal-slider', settings);
        gallerySlider.slideTo(activeSlide)
      });

      $(document).on("click",".js-gallery-close",function() {
        sliderClose()
      });

      $(document).mouseup(function(e) { 
        var container = $(".js-modal-slider");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          sliderClose()
        }
      });

      $('.js-variant-changer:first-child').addClass('m-current')

      $(document).on("click",".product-single__buttons-inner:not(.m-active) .product-single__buttons",function() {
        $(this).closest('.product-single__buttons-inner').addClass('m-active')
      });

      $(document).on("click",".m-active .product-single__variant-btn",function() {
        $(this).closest('.product-single__buttons-inner').removeClass('m-active');
        $(this).closest('.product-single__buttons').find('.product-single__variant-btn').removeClass('m-current')
        $(this).addClass('m-current')
      });

      function tonsCalc() {
        let currentVariantData = $(".js-variant-changer.m-current").data('value'),
            clearValue = currentVariantData.split('(')[0],
            clearValueNum = clearValue.replace(/[^0-9]/g,''),
            countVariants = $('#Quantity-product-template').val(),
            calculatedTons = clearValueNum * countVariants;
        $('#Quantity-product-template').attr('value', countVariants )
        $('.js-current-variant span').text(calculatedTons);
        $('.js-tons').text(calculatedTons);
        $('.product-single__calc').show()
      }

      tonsCalc();

      $(document).on("click",".quantity__btn, .js-variant-changer",function() {
        tonsCalc();
      });

      $(document).click(function(event) { 
        if ($('.product-single__buttons-inner').hasClass('m-active')) {
          var $target = $(event.target);
          if(!$target.closest('.product-single__buttons-inner').length && 
          $('.product-single__buttons-inner').is(":visible")) {
            $('.product-single__variant-btn.active').trigger('click')
          }  
        }      
      });
    }

    if ($('body').hasClass('template-cart')) {

      $(document).on("click",".js-checkout-trigger",function() {
        checkFlags()
      });
      $(document).on("click",".js-trigger-submit",function(e) {
        e.preventDefault()
        checkFlags()
      })
      function checkFlags() {
        let checked = true;

        $('.cart__submit-checkbox input').each(function() {
          if(!($(this).is(':checked'))) {
            checked = false;
            $(this).closest('.cart__submit-checkbox').addClass('invalid');
          }
        })
        if(checked) {
          // data = {
          //   "id": '47042977104205',
          //   "quantity": 1
          // }
          
          // jQuery.ajax({
          //   type: 'POST',
          //   url: '/cart/add.js',
          //   data: data,
          //   dataType: 'json',
          //   success: function() { 
          //     $('.cart__buttons-container input[type=submit]').trigger('click');
          //   }
          // });
          $('.cart__buttons-container input[type=submit]').trigger('click');
        } else {
          $('html, body').animate({
            scrollTop: $($('.cart__submit-checkbox')[0]).offset().top - 50
          }, 1000);
        }
      }
    }

    $('[data-quantity-input]').each(function () {
      $(this).on('change', function() {
        $(this).attr('value', $(this).val())
      })
    })

})

$(window).on('load', function(){
  if ($('.ajx-products__variants').length) {

    function availabeChecker() {
      let variantAtive = $('.ajx-products__product-variant.m-current')
      if ($("body").hasClass('template-product')) {
        // setTimeout(function() {
        //   if ($('.ajx-products__product-variant').hasClass('m-current')) {
        //     variantAtive.closest(".ajx-products__card").find('.m-availabe').show()
        //   }
        // }, 1000);
      } else {
        if ($('.ajx-products__product-variant').hasClass('m-current')) {
          variantAtive.closest(".ajx-products__card").find('.m-availabe').show()
        }
      }
    }

    availabeChecker()
  }

  if ($('.ajx-products__variants').length) {

    $('.ajx-products__product-variant:first-child').addClass('m-current')

    $(document).on("click",".ajx-products__variants:not(.m-active) .ajx-products__sc-variants",function() {
      $(this).closest('.ajx-products__variants').addClass('m-active')
    });

    $(document).on("click",".m-active .js-ajx-vr",function() {
      let currentVariant = $(this).data('id'),
          currentPrice = $(this).data('price');
      $(this).closest('.ajx-products__variants').removeClass('m-active');
      $(this).closest('.ajx-products__card').find('select').val(currentVariant)
      $(this).closest('.ajx-products__sc-variants').find('.js-ajx-vr').removeClass('m-current')
      $(this).addClass('m-current')
      $(this).closest('.ajx-products__inner').find('.ajx-products__price strong').text(currentPrice);

      if($(this).attr('data-availabe') === 'false') {
        $(this).closest('.ajx-products__card').find('.product-form__cart-submit').attr('disabled', true);
        $(this).closest('.ajx-products__card').find('.product-form__cart-submit').text('Изчерпано');
      } else {
        $(this).closest('.ajx-products__card').find('.product-form__cart-submit').attr('disabled', false);
        $(this).closest('.ajx-products__card').find('.product-form__cart-submit').text('Добавяне към количката');
      }
    });
  }

  if ($('body').hasClass('template-collection')) {
    // $('.collection .product-form__cart-submit').each(function () {
    //   let elem = $(this),
    //       elemVar = $(this).closest('.grid__item').find('.js-ajx-vr.m-current'),
    //       elemId = $(elemVar).data('id'),
    //       elemPrice = $(elemVar).data('price'),
    //       elemQty = "1",
    //       elemPackaging = $(elemVar).text();
    //   elem[0].dispatchEvent(new CustomEvent("addToCart", {
    //     detail: {
    //       'id' : elemId, 
    //       'price' : elemPrice,
    //       'qty' : elemQty,
    //       'packaging': elemPackaging
    //     }
    //   }));
    // })
  }
  if ($('body').hasClass('template-customers-login')) {
    setTimeout(function() {
      $('.header_login #my_button').trigger('click')
    }, 500)
  }

  if ($('body').hasClass('template-index')) {
    let settings = {
      loop: true,
      speed: 1500,
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.banner-pagination',
        type: 'bullets',
        clickable: true
      },
    },
    
    bannerSlider = new Swiper('.js-banner-slider', settings);
  }
   

});